import React from "react";

const Em = ({ children }) => {
  return <em>{children}</em>;
};

export default Em;
